import PhoneNumberField from '../../fields/phone-number-field/phone-number-field.component'

const AddDriverForm = () => {
  return <PhoneNumberField name="phone" />
}

export default AddDriverForm
